import { render, staticRenderFns } from "./AlertCount.vue?vue&type=template&id=38c166ca"
import script from "./AlertCount.vue?vue&type=script&lang=js"
export * from "./AlertCount.vue?vue&type=script&lang=js"
import style0 from "./AlertCount.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports